import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";

export const getProjects = (type: string, name: string) =>
  createAsyncThunk(name, async () => {
    try {
      const response = await axios.post(`${baseUrlApi}projects`, {
        headers: {
          "Content-Type": "application/json",
        },
        type,
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  });

/*--------------------------GET ALL Public PROJECTS---------------------------*/
export const getGeneralProjects = getProjects("general", "projects/general");
/*--------------------------GET ALL SEASONAL PROJECTS---------------------------*/
export const getSeasonalProjects = getProjects("seasonal", "projects/seasonal");
/*--------------------------GET HOME PAGE SEASONAL PROJECTS ---------------------------*/
export const getHomeProjects = getProjects("homepage", "projects/homepage");
/*--------------------------GET BRANCH PROJECTS BY BRANCH ID---------------------------*/
export const getBranchProjects = createAsyncThunk(
  "projects/branch",
  async (branch_id: number) => {
    try {
      const response = await axios.post(`${baseUrlApi}projects`, {
        headers: {
          "Content-Type": "application/json",
        },
        type: "branch",
        branch_id,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getDetailsProjects = createAsyncThunk(
  "seasonalProjects/getDetailsProjects",
  async (id: string | undefined) => {
    try {
      const response = await axios.get(
        `${baseUrlApi}projects/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
/*--------------------------GET ALL SEASONAL PROJECTS---------------------------*/
export const getAllProjectsTypes = createAsyncThunk(
  "project/types",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}project/types`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
// get project branches
export const getProjectBranches = createAsyncThunk(
  "project/branches",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}projects/branches`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response?.data;
    } catch (error) {
      throw error;
    }
  },
);
